export default __webpack_public_path__ + "static/media/acuity.515e0fc6.svg";